module.exports = __webpack_public_path__ + "img/manual-slots-01-slots-page.08f851ac.png";